import React, { useEffect, useState } from 'react';
//import { getVoices } from '../Script';
import {getCachedData} from '../Firebase'
import 'swiper/css';
import playIcon from '../assets/play_icon.svg';
import playIcon_white from '../assets/play_icon_white.svg';
import pauseIcon from '../assets/pause_icon.svg'; // Import a pause icon
import pauseIcon_white from '../assets/pause_icon_white.svg'; // Import a pause icon
import VoiceSkeleton from './VoiceSkeleton'

export default function ChooseVoice({ onVoiceSelected }) {
    const [voices, setVoices] = useState([]);
    const [selectedVoice, setSelectedVoice] = useState(null);
    const [audio, setAudio] = useState(null);
    const [playingVoiceId, setPlayingVoiceId] = useState(null);

    useEffect(() => {
        // getVoices().then((voices) => {
        //     setVoices(voices);
        // });
        getCachedData("voices").then((voices) => {
            setVoices(voices);
        });
    }, []);

    const playVoice = (voice) => {
        if (audio) {
            audio.pause();
            setPlayingVoiceId(null);
        }

        if (playingVoiceId === voice.voice_id) {
            setPlayingVoiceId(null);
            return;
        }

        const newAudio = new Audio(voice.preview_audio);
        newAudio.play();
        setAudio(newAudio);
        setPlayingVoiceId(voice.voice_id);

        newAudio.onended = () => {
            setPlayingVoiceId(null);
        };
    };

    const handleSelectVoice = (voice) => {
        setSelectedVoice(voice);
        onVoiceSelected(voice)
    };

    return (
        <div className="container d-flex flex-column gap-4 pb-4">
            <h1>Choose a Voice</h1>
           

            {voices.length > 0 ? voices.map((voice, index) => (
                <div
                    key={index}
                    className={`button-modal d-flex flex-row justify-content-between align-items-center ${selectedVoice === voice ? "selected-voice" : ""
                        }`}
                    style={{
                        background: selectedVoice === voice ? "black" : "#8080802b",
                        cursor: "pointer",
                    }}
                    onClick={() => handleSelectVoice(voice)} // Make the whole div clickable
                >
                    <div className="d-flex gap-3 align-items-center">
                        {/* <img
                            className="circle-image"
                            src={require(`../assets/${voice.name}.png`)}
                            alt="Voice Avatar"
                        /> */}

                       
                        <h1 className="mb-0" style={{ color: selectedVoice === voice ? "white" : "black" }}>
                            {voice.name}
                        </h1>
                    </div>

                    <div className="d-flex gap-4 align-items-center">
                        <img
                            src={
                                playingVoiceId === voice.voice_id
                                    ? (selectedVoice === voice ? pauseIcon_white : pauseIcon)
                                    : (selectedVoice === voice ? playIcon_white : playIcon)
                            }
                            alt="Play/Pause Icon"
                            style={{ cursor: "pointer", maxHeight: "18px", marginRight:'10px' }}
                            onClick={(e) => {
                                e.stopPropagation(); // Prevent the div click from triggering
                                playVoice(voice);
                            }}
                        />

                        {/* <input
                            type="radio"
                            name="voiceSelection"
                            checked={selectedVoice === voice}
                            readOnly
                            className="custom-radio"
                        /> */}
                    </div>
                </div>
            )) : (
                <div>
                    <VoiceSkeleton/>
                    <VoiceSkeleton/>
                    <VoiceSkeleton/>
                    <VoiceSkeleton/>
                    <VoiceSkeleton/>
                    <VoiceSkeleton/>
                    </div>
            )}

           
        </div>
    );
}
